module.exports = __webpack_public_path__ + "static/media/logo_petz.07a9a5bf.svg";